import { useEffect, useRef, useState } from 'react'

import { useResponsiveSize } from './useResponsiveSize'

export function useOverflowStatus() {
    const ref = useRef<HTMLDivElement>(null)
    const [overflowing, setOverflowing] = useState(false)
    const { vw, vh } = useResponsiveSize()

    useEffect(() => {
        if (!ref.current) return

        setOverflowing(
            ref.current.scrollWidth > ref.current.clientWidth ||
                ref.current.scrollHeight > ref.current.clientHeight
        )
    }, [ref, vw, vh])

    return { overflowing, ref }
}
